import { render, staticRenderFns } from "./SimpleConfirmModal.vue?vue&type=template&id=25c5f49b&scoped=true"
import script from "./SimpleConfirmModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SimpleConfirmModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SimpleConfirmModal.vue?vue&type=style&index=0&id=25c5f49b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c5f49b",
  null
  
)

export default component.exports